import { TOKEN } from 'constants/global.constants'

export const clearAuthStoragePreservingMfaDevice = (): void => {
  localStorage.removeItem(TOKEN)
  localStorage.removeItem('persist:root')
}
